<template>
<div class="contents">
      <div class="wrap">
        <section>
          <h2 class="page_title --view">기간별약재사용량관리</h2>
          <article>
            <ul class="search_filter">
              <li>
                <p>약재명</p>
                <input type="text" placeholder="약재명을 입력하세요" class="form_control" v-model="searchInfo.medicineNm" @change="fn_page_init" @keyup.enter="fn_search">
              </li>
              <!-- <li>
                <div class="form_radio">
                  <input type="radio" id="radio1" name="radio" value="wrhs" checked v-model="searchInfo.chk_info">
                  <label for="radio1">입고기간</label>
                </div>
                <div class="form_radio">
                  <input type="radio" id="radio2" name="radio" value="expr" v-model="searchInfo.chk_info">
                  <label for="radio2">유통기한 만료</label>
                </div>
              </li> -->
              <li>
                  <p>조회기간</p>
                  <Datepicker v-model="searchInfo.startDt" :defaultDate="searchInfo.startDt" :format="'YYYY-MM-DD'" @change="fn_page_init"/>
                  ~
                  <Datepicker v-model="searchInfo.endDt" :defaultDate="searchInfo.endDt" :format="'YYYY-MM-DD'" @change="fn_page_init"/>
              </li>
              <li>
                <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
              </li>
            </ul>
          </article>
        </section>
        <section class="view">
          <div class="table_list">
            <div class="table_option">
<!--              <div class="form_select">-->
<!--                <p>정렬</p>-->
<!--                <b-form-select v-model="searchInfo.selected">-->
<!--                  <b-form-select-option :value="null">전체</b-form-select-option>-->
<!--                  <b-form-select-option value="m">약재명</b-form-select-option>-->
<!--                  <b-form-select-option value="u">사용량</b-form-select-option>-->
<!--                </b-form-select>-->
<!--              </div>-->
<!--              <button class="btn btn_md btn_outline" @click="fn_move_reg_page">엑셀다운로드</button>-->
            </div>
            <table class="list">
              <colgroup>
                <col width="300">
              </colgroup>
              <thead>                  
                <tr>
                    <th>약재명</th>
                    <th>제조회사</th>
                    <th>원산지</th>
                    <th>사용량</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="herbUsageReportList.length == 0">
                    <td colspan="10"><span>데이터가 없습니다.</span></td>
                </tr>
                <tr v-for="(item, index) in herbUsageReportList" :key="index">
                  <td class="al"><span>{{ item.med_hrb_nm }}</span></td>
                  <td><span>{{ item.org_plce_nm }}</span></td>
                  <td><span>{{ item.pharmaceutical_company_nm }}</span></td>
                  <td><span>{{ item.total_use_qnty }} g</span></td>
                </tr>
              </tbody>
            </table>
            <Pagination :pageInfo=searchInfo.pageInfo @clickPage="moveGrpPage" v-show="pagingShow"/>
          </div>
        </section>
      </div>

    </div>
</template>

<script>
    import axios from 'axios'
    import Pagination from "@/components/AdminPagination.vue"
    import Datepicker from '@/components/Datepicker.vue'
    import commonUtil from "@/mixin/commonUtil"

export default {
    name: 'herbUsageReport',
    mixins: [commonUtil],
    components: {
      Pagination,
      Datepicker,
    },
    data() {
      return {
        searchInfo : {
            medicineNm : '',
            startDt : '',
            endDt: '',
            pageInfo : {  
              page : '1',
              pageSize : '10',
              totPage : '0'
            } 
        },
        changeInfo : false,
        pagingShow : false,
        herbUsageReportList: [],
      }
    },
    created(){
      //오늘 날짜구하기
      this.searchInfo.startDt =  this.getAddMonthDate(-1);
      this.searchInfo.endDt = this.getCurrentDate();
    },
    mounted(){
        //오늘 날짜구하기
        this.searchInfo.startDt =  this.getAddMonthDate(-1);
        this.searchInfo.endDt = this.getCurrentDate();
        this.fn_search();
    },
    methods : {
        fn_search(){

            //console.log("@@@@ regData : %o",this.regData);
            if(this.changeInfo){
                this.searchInfo.pageInfo.page = '1';
            }
            axios
                .post("/api/medicineWrhs/getHerbUsageReprotList", this.searchInfo)
                .then((res) => {
                    console.log("@@@@ res : %o",res);
                    this.herbUsageReportList = res.data.herbUsageReportList;

                    console.log("@@@@ herbUsageReportList : %o",this.herbUsageReportList);

                    this.searchInfo.pageInfo.totPage = res.data.totCnt;

                    if(this.searchInfo.pageInfo.totPage> 0){
                      this.pagingShow = true;
                    }

                    this.changeInfo = false;
                })
                .catch((err) => console.log(err));
            
        },
        moveGrpPage(page){
            this.searchInfo.pageInfo.page = page;
            this.fn_search();
        },
        fn_page_init(){
            this.changeInfo = true;
        }
        // fn_move_dtl_page(code){
        //     console.log("@@@@ MedWhrsCd : "+code);
        //     this.$store.dispatch('medWrhs/setMedWhrsCd', code);
        //     this.$router.push({ name : 'MedicineWrhsMngtDtl'});
        // },
    }   
  }
</script>